module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-BoldItalic.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-BoldItalic.woff2
// module id = 56
// module chunks = 8